<template>
  <div class="calculator bitwise">
    <h1 class="page-header">Bitwise Calculator</h1>
    <fieldset id="bitshift">
      <el-row type="flex" align="middle" justify="center" :gutter="5">
        <el-col :span="4">
          <el-input v-model="shiftStart"></el-input>
        </el-col>
        <el-col :span="4">
          <base-radio
            id="shift-selector"
            :value="shiftOperator"
            :options="bitshiftOptions"
            @set-new-value="shiftOperator = $event.newValue"
          >
          </base-radio>
        </el-col>
        <el-col :span="4">
          <el-input v-model="shiftBy"></el-input>
        </el-col>
        <el-col :span="1">=</el-col>
        <el-col class="calc-result" :span="4">{{ shiftResult }}</el-col>
      </el-row>
      <br />
      <el-row type="flex" align="middle" justify="center" :gutter="5">
        <el-col class="calc-text" :span="4">{{ shiftStartBinary }}</el-col>
        <el-col class="calc-text" :span="4">{{ shiftOperatorSymbol }}</el-col>
        <el-col class="calc-text" :span="4">{{ shiftBy }}</el-col>
        <el-col class="calc-text" :span="1">=</el-col>
        <el-col class="calc-result" :span="4">{{ shiftResultBinary }}</el-col>
      </el-row>
    </fieldset>
    <br />
    <br />
    <fieldset id="bitwise">
      <el-row type="flex" align="middle" justify="center" :gutter="5">
        <el-col :span="4">
          <el-input v-model="val1"></el-input>
        </el-col>
        <el-col :span="4">
          <base-radio
            id="wise-selector"
            :value="wiseOperator"
            :options="bitwiseOptions"
            @set-new-value="wiseOperator = $event.newValue"
          >
          </base-radio>
        </el-col>
        <el-col :span="4">
          <el-input v-model="val2"></el-input>
        </el-col>
        <el-col class="class-text" :span="1">=</el-col>
        <el-col class="calc-result" :span="4">{{ wiseResult }}</el-col>
      </el-row>
      <br />
      <el-row type="flex" align="middle" justify="center" :gutter="5">
        <el-col class="calc-text" :span="4">{{ val1Binary }}</el-col>
        <el-col class="calc-text" :span="4">{{ wiseOperatorSymbol }}</el-col>
        <el-col class="calc-text" :span="4">{{ val2Binary }}</el-col>
        <el-col class="calc-text" :span="1">=</el-col>
        <el-col class="calc-result" :span="4">{{ wiseResultBinary }}</el-col>
      </el-row>
    </fieldset>
  </div>
</template>

<script>
import { dec2bin } from "@/utils/conversions.js"
import { optionList } from "@/utils/options.js"
import BaseRadio from "@/components/BaseRadio.vue"

const BITSHIFT_OPRS = {
  left: "<<",
  right: ">>",
}

const BITWISE_OPRS = {
  AND: "&",
  OR: "|",
  XOR: "^",
}

export default {
  name: "Bitwise",
  components: {
    BaseRadio,
  },
  data() {
    return {
      shiftStart: 255,
      shiftOperator: "right",
      shiftBy: 1,
      val1: 255,
      val2: 1,
      wiseOperator: "AND",
    }
  },
  computed: {
    bitshiftOptions() {
      return optionList(BITSHIFT_OPRS)
    },
    bitwiseOptions() {
      return optionList(BITWISE_OPRS)
    },
    shiftResult() {
      if (this.shiftOperator == "left") {
        return this.shiftStart << this.shiftBy
      }
      return this.shiftStart >> this.shiftBy
    },
    shiftResultBinary() {
      const result = this.shiftResult
      return dec2bin(result)
    },
    shiftStartBinary() {
      const from = this.shiftStart
      return dec2bin(from)
    },
    shiftOperatorSymbol() {
      return BITSHIFT_OPRS[this.shiftOperator]
    },
    wiseResult() {
      if (this.wiseOperator === "AND") {
        return this.val1 & this.val2
      } else if (this.wiseOperator === "OR") {
        return this.val1 | this.val2
      }
      return this.val1 ^ this.val2
    },
    val1Binary() {
      return dec2bin(this.val1)
    },
    val2Binary() {
      return dec2bin(this.val2)
    },
    wiseOperatorSymbol() {
      return BITWISE_OPRS[this.wiseOperator]
    },
    wiseResultBinary() {
      return dec2bin(this.wiseResult)
    },
  },
}
</script>

<style scoped>
</style>